import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { IntegrationRetryOption } from './Pages';

export const IntegrationRetryOptionRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={IntegrationRetryOption} />
    </Fragment>
)